<starters-dispensation-button></starters-dispensation-button>
<additional-info
    [key]="questionKey"
    titleKey="income.starters-dispensation.additional-info.text"
    contentKey="income.starters-dispensation.additional-info.content"
    modalUrlKey="income.starters-dispensation.additional-info.text"
></additional-info>
